import tenantAxiosInstance from "../../scenes/utils/tenantAxiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class PermissionGroupService {
  // Get all permission groups for tenant
  getAllGroups = async () => {
    try {
      const response = await tenantAxiosInstance.get(API_ENDPOINTS.PERMISSION_GROUPS.ALL);
      return response.data;
    } catch (error) {
      console.error("Get all permission groups error:", error);
      throw error;
    }
  };

  // Get single permission group by ID
  getGroupById = async (groupId) => {
    try {
      const response = await tenantAxiosInstance.get(API_ENDPOINTS.PERMISSION_GROUPS.BY_ID(groupId));
      return response.data;
    } catch (error) {
      console.error("Get permission group by ID error:", error);
      throw error;
    }
  };

  // Create new permission group
  createGroup = async (groupData) => {
    try {
      const response = await tenantAxiosInstance.post(API_ENDPOINTS.PERMISSION_GROUPS.CREATE, groupData);
      return response.data;
    } catch (error) {
      console.error("Create permission group error:", error);
      throw error;
    }
  };

  // Update permission group
  updateGroup = async (groupId, groupData) => {
    try {
      const response = await tenantAxiosInstance.put(API_ENDPOINTS.PERMISSION_GROUPS.UPDATE(groupId), groupData);
      return response.data;
    } catch (error) {
      console.error("Update permission group error:", error);
      throw error;
    }
  };

  // Delete permission group
  deleteGroup = async (groupId) => {
    try {
      const response = await tenantAxiosInstance.delete(API_ENDPOINTS.PERMISSION_GROUPS.DELETE(groupId));
      return response.data;
    } catch (error) {
      console.error("Delete permission group error:", error);
      throw error;
    }
  };

  // Get doctor's assigned groups
  getDoctorGroups = async (doctorId) => {
    try {
      const response = await tenantAxiosInstance.get(API_ENDPOINTS.PERMISSION_GROUPS.DOCTOR_GROUPS(doctorId));
      return response.data;
    } catch (error) {
      console.error("Get doctor groups error:", error);
      throw error;
    }
  };

  // Assign permission group to doctor
  assignGroupToDoctor = async (doctorId, groupId) => {
    try {
      const response = await tenantAxiosInstance.post(API_ENDPOINTS.PERMISSION_GROUPS.ASSIGN_DOCTOR, {
        doctorId,
        groupId
      });
      return response.data;
    } catch (error) {
      console.error("Assign group to doctor error:", error);
      throw error;
    }
  };

  // Remove permission group from doctor
  removeGroupFromDoctor = async (doctorId, groupId) => {
    try {
      const response = await tenantAxiosInstance.delete(API_ENDPOINTS.PERMISSION_GROUPS.REMOVE_DOCTOR(doctorId, groupId));
      return response.data;
    } catch (error) {
      console.error("Remove group from doctor error:", error);
      throw error;
    }
  };

  // Get available permission resources and operations
  getPermissionStructure = () => {
    return {
      admin: {
        files: ['create', 'update', 'view', 'delete'],
        forms: ['create', 'update', 'view', 'delete'],
        patients: ['create', 'update', 'view', 'delete'],
        doctors: ['create', 'update', 'view', 'delete'],
        form_answers: ['create', 'update', 'view', 'delete'],
        invitations: ['create', 'update', 'view', 'delete'],
        mr: ['create', 'update', 'view', 'delete'],
        segmentation: ['create', 'view', 'delete'],
        scoring_formulas: ['create', 'update', 'view', 'delete'],
        patient_files: ['upload', 'update', 'view', 'delete'],
        permission_groups: ['create', 'update', 'view', 'delete'],
      },
      doctor: {
        own_patients: ['create', 'update', 'view', 'delete'],
        own_form_answers: ['create', 'update', 'view', 'delete'],
        own_mr: ['create', 'view', 'delete'],
        own_patient_files: ['upload', 'update', 'view', 'delete'],
        view_forms: ['view'],
        view_files: ['view'],
      }
    };
  };

  // Get permission labels (user-friendly names)
  getPermissionLabels = () => {
    return {
      resources: {
        files: 'Files',
        forms: 'Forms',
        patients: 'Patients',
        doctors: 'Doctors',
        form_answers: 'Form Answers',
        invitations: 'Form Invitations',
        mr: 'Medical Records',
        segmentation: 'Segmentation',
        scoring_formulas: 'Scoring Formulas',
        patient_files: 'Patient Files',
        permission_groups: 'Permission Groups',
        own_patients: 'Own Patients',
        own_form_answers: 'Own Form Answers',
        own_mr: 'Own Medical Records',
        own_patient_files: 'Own Patient Files',
        view_forms: 'View Forms',
        view_files: 'View Files',
      },
      operations: {
        create: 'Create',
        update: 'Update',
        view: 'View',
        delete: 'Delete',
        upload: 'Upload',
      }
    };
  };
}

